import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";

var _dec, _dec2, _dec3, _class, _class2, _descriptor, _descriptor2;

import { TYPES } from '@antv/l7-core';
import { Version } from '@antv/l7-maps';
import { isColor, normalize, rgb2arr } from '@antv/l7-utils';
import { inject, injectable } from 'inversify';
import { cloneDeep } from 'lodash';
import 'reflect-metadata';
var DataMappingPlugin = (_dec = injectable(), _dec2 = inject(TYPES.IMapService), _dec3 = inject(TYPES.IFontService), _dec(_class = (_class2 = /*#__PURE__*/function () {
  function DataMappingPlugin() {
    _classCallCheck(this, DataMappingPlugin);

    _initializerDefineProperty(this, "mapService", _descriptor, this);

    _initializerDefineProperty(this, "fontService", _descriptor2, this);
  }

  _createClass(DataMappingPlugin, [{
    key: "apply",
    value: function apply(layer, _ref) {
      var _this = this;

      var styleAttributeService = _ref.styleAttributeService;
      layer.hooks.init.tap('DataMappingPlugin', function () {
        // 初始化重新生成 map
        var source = layer.getSource();

        if (source.inited) {
          _this.generateMaping(layer, {
            styleAttributeService: styleAttributeService
          });
        } else {
          source.once('update', function () {
            _this.generateMaping(layer, {
              styleAttributeService: styleAttributeService
            });
          });
        }
      });
      layer.hooks.beforeRenderData.tap('DataMappingPlugin', function () {
        layer.dataState.dataMappingNeedUpdate = false;
        var source = layer.getSource();

        if (source.inited) {
          _this.generateMaping(layer, {
            styleAttributeService: styleAttributeService
          });
        } else {
          source.once('update', function () {
            _this.generateMaping(layer, {
              styleAttributeService: styleAttributeService
            });
          });
        }

        return true;
      }); // remapping before render

      layer.hooks.beforeRender.tap('DataMappingPlugin', function () {
        var _layer$getLayerConfig = layer.getLayerConfig(),
            usage = _layer$getLayerConfig.usage;

        if (usage === 'basemap') return;
        var source = layer.getSource();

        if (layer.layerModelNeedUpdate || !source || !source.inited) {
          return;
        }

        var bottomColor = layer.getBottomColor();
        var attributes = styleAttributeService.getLayerStyleAttributes() || [];
        var filter = styleAttributeService.getLayerStyleAttribute('filter');
        var dataArray = source.data.dataArray;
        var attributesToRemapping = attributes.filter(function (attribute) {
          return attribute.needRemapping;
        } // 如果filter变化
        );
        var filterData = dataArray; // 数据过滤完 再执行数据映射

        if (filter !== null && filter !== void 0 && filter.needRemapping && filter !== null && filter !== void 0 && filter.scale) {
          filterData = dataArray.filter(function (record) {
            return _this.applyAttributeMapping(filter, record, bottomColor)[0];
          });
        }

        if (attributesToRemapping.length) {
          // 过滤数据
          if (filter !== null && filter !== void 0 && filter.needRemapping) {
            var encodeData = _this.mapping(layer, attributes, filterData, undefined, bottomColor);

            layer.setEncodedData(encodeData);
            filter.needRemapping = false;
          } else {
            var _encodeData = _this.mapping(layer, attributesToRemapping, filterData, layer.getEncodedData(), bottomColor);

            layer.setEncodedData(_encodeData);
          } // 处理文本更新


          layer.emit('remapping', null);
        }
      });
    }
  }, {
    key: "generateMaping",
    value: function generateMaping(layer, _ref2) {
      var _this2 = this;

      var styleAttributeService = _ref2.styleAttributeService;
      var bottomColor = layer.getBottomColor();
      var attributes = styleAttributeService.getLayerStyleAttributes() || [];
      var filter = styleAttributeService.getLayerStyleAttribute('filter');
      var dataArray = layer.getSource().data.dataArray;
      var filterData = dataArray; // 数据过滤完 再执行数据映射

      if (filter !== null && filter !== void 0 && filter.scale) {
        filterData = dataArray.filter(function (record) {
          return _this2.applyAttributeMapping(filter, record, bottomColor)[0];
        });
      }

      var encodeData = this.mapping(layer, attributes, filterData, undefined, bottomColor);
      layer.setEncodedData(encodeData); // 对外暴露事件

      layer.emit('dataUpdate', null);
    }
  }, {
    key: "mapping",
    value: function mapping(layer, attributes, data, predata, minimumColor) {
      var _this3 = this;

      var _ref3 = layer.getLayerConfig(),
          _ref3$arrow = _ref3.arrow,
          arrow = _ref3$arrow === void 0 ? {
        enable: false
      } : _ref3$arrow,
          usage = _ref3.usage;

      if (usage === 'basemap') {
        return this.mapLayerMapping(layer, attributes, data, predata);
      }

      var usedAttributes = attributes.filter(function (attribute) {
        return attribute.scale !== undefined;
      });
      var mappedData = data.map(function (record, i) {
        var preRecord = predata ? predata[i] : {};

        var encodeRecord = _objectSpread({
          id: record._id,
          coordinates: record.coordinates
        }, preRecord);

        usedAttributes.forEach(function (attribute) {
          var values = _this3.applyAttributeMapping(attribute, record, minimumColor);

          attribute.needRemapping = false; // TODO: 支持每个属性配置 postprocess

          if (attribute.name === 'color') {
            values = values.map(function (c) {
              return rgb2arr(c);
            });
          } // @ts-ignore


          encodeRecord[attribute.name] = Array.isArray(values) && values.length === 1 ? values[0] : values; // 增加对 layer/text/iconfont unicode 映射的解析

          if (attribute.name === 'shape') {
            encodeRecord.shape = _this3.fontService.getIconFontKey(encodeRecord[attribute.name]);
          }
        });

        if (arrow.enable && (encodeRecord.shape === 'line' || encodeRecord.shape === 'halfLine')) {
          // 只有在线图层且支持配置箭头的时候进行插入顶点的处理
          var coords = encodeRecord.coordinates; // @ts-ignore

          if (layer.arrowInsertCount < layer.encodeDataLength) {
            // Tip: arrowInsert 的判断用于确保每一条线数据 arrow 的属性点只会被植入一次
            var arrowPoint = _this3.getArrowPoints(coords[0], coords[1]);

            encodeRecord.coordinates.splice(1, 0, arrowPoint, arrowPoint); // @ts-ignore

            layer.arrowInsertCount++;
          }
        }

        return encodeRecord;
      }); // 调整数据兼容 Amap2.0

      this.adjustData2Amap2Coordinates(mappedData, layer); // 调整数据兼容 SimpleCoordinates

      this.adjustData2SimpleCoordinates(mappedData);
      return mappedData;
    }
  }, {
    key: "mapLayerMapping",
    value: function mapLayerMapping(layer, attributes, data, predata) {
      var _this4 = this;

      var usedAttributes = attributes.filter(function (attribute) {
        return attribute.scale !== undefined;
      });
      var mappedData = data.map(function (record, i) {
        var preRecord = predata ? predata[i] : {};

        var encodeRecord = _objectSpread({
          id: record._id,
          coordinates: record.coordinates
        }, preRecord);

        usedAttributes.forEach(function (attribute) {
          var _layer$shapeOption;

          if (attribute.name === 'shape' && // @ts-ignore
          ((_layer$shapeOption = layer.shapeOption) === null || _layer$shapeOption === void 0 ? void 0 : _layer$shapeOption.field) === 'simple') {
            encodeRecord[attribute.name] = 'simple';
            attribute.needRemapping = false;
          } else {
            var values = _this4.applyMapLayerAttributeMapping(attribute, record);

            attribute.needRemapping = false; // @ts-ignore

            encodeRecord[attribute.name] = Array.isArray(values) && values.length === 1 ? values[0] : values; // 增加对 layer/text/iconfont unicode 映射的解析

            if (attribute.name === 'shape') {
              encodeRecord.shape = _this4.fontService.getIconFontKey(encodeRecord[attribute.name]);
            }
          }
        });

        if (encodeRecord.size === undefined) {
          // in case not set size
          encodeRecord.size = 1;
        }

        return encodeRecord;
      }); // 调整数据兼容 Amap2.0

      this.adjustData2Amap2Coordinates(mappedData, layer);
      return mappedData;
    }
  }, {
    key: "adjustData2Amap2Coordinates",
    value: function adjustData2Amap2Coordinates(mappedData, layer) {
      var _this5 = this;

      // 根据地图的类型判断是否需要对点位数据进行处理, 若是高德2.0则需要对坐标进行相对偏移
      if (mappedData.length > 0 && this.mapService.version === Version['GAODE2.x']) {
        var layerCenter = layer.coordCenter || layer.getSource().center;

        if (typeof mappedData[0].coordinates[0] === 'number') {
          // 单个的点数据
          // @ts-ignore
          mappedData // TODO: 避免经纬度被重复计算导致坐标位置偏移
          .filter(function (d) {
            return !d.originCoordinates;
          }).map(function (d) {
            d.version = Version['GAODE2.x']; // @ts-ignore

            d.originCoordinates = cloneDeep(d.coordinates); // 为了兼容高德1.x 需要保存一份原始的经纬度坐标数据（许多上层逻辑依赖经纬度数据）
            // @ts-ignore
            // d.coordinates = this.mapService.lngLatToCoord(d.coordinates);

            d.coordinates = _this5.mapService.lngLatToCoordByLayer(d.coordinates, layerCenter);
          });
        } else {
          // 连续的线、面数据
          mappedData // TODO: 避免经纬度被重复计算导致坐标位置偏移
          .filter(function (d) {
            return !d.originCoordinates;
          }).map(function (d) {
            d.version = Version['GAODE2.x']; // @ts-ignore

            d.originCoordinates = cloneDeep(d.coordinates); // 为了兼容高德1.x 需要保存一份原始的经纬度坐标数据（许多上层逻辑依赖经纬度数据）
            // @ts-ignore
            // d.coordinates = this.mapService.lngLatToCoords(d.coordinates);

            d.coordinates = _this5.mapService.lngLatToCoordsByLayer(d.coordinates, layerCenter);
          });
        }
      }
    }
  }, {
    key: "adjustData2SimpleCoordinates",
    value: function adjustData2SimpleCoordinates(mappedData) {
      var _this6 = this;

      if (mappedData.length > 0 && this.mapService.version === Version.SIMPLE) {
        mappedData.map(function (d) {
          if (!d.simpleCoordinate) {
            d.coordinates = _this6.unProjectCoordinates(d.coordinates);
            d.simpleCoordinate = true;
          }
        });
      }
    }
  }, {
    key: "unProjectCoordinates",
    value: function unProjectCoordinates(coordinates) {
      var _this7 = this;

      if (typeof coordinates[0] === 'number') {
        return this.mapService.simpleMapCoord.unproject(coordinates);
      }

      if (coordinates[0] && coordinates[0][0] instanceof Array) {
        // @ts-ignore
        var coords = [];
        coordinates.map(function (coord) {
          // @ts-ignore
          var c1 = [];
          coord.map(function (co) {
            c1.push(_this7.mapService.simpleMapCoord.unproject(co));
          }); // @ts-ignore

          coords.push(c1);
        }); // @ts-ignore

        return coords;
      } else {
        // @ts-ignore
        var _coords = []; // @ts-ignore

        coordinates.map(function (coord) {
          _coords.push(_this7.mapService.simpleMapCoord.unproject(coord));
        }); // @ts-ignore

        return _coords;
      }
    }
  }, {
    key: "applyAttributeMapping",
    value: function applyAttributeMapping(attribute, record, minimumColor) {
      var _attribute$scale;

      if (!attribute.scale) {
        return [];
      }

      var scalers = (attribute === null || attribute === void 0 ? void 0 : (_attribute$scale = attribute.scale) === null || _attribute$scale === void 0 ? void 0 : _attribute$scale.scalers) || [];
      var params = [];
      scalers.forEach(function (_ref4) {
        var _attribute$scale2;

        var field = _ref4.field;

        if (record.hasOwnProperty(field) || ((_attribute$scale2 = attribute.scale) === null || _attribute$scale2 === void 0 ? void 0 : _attribute$scale2.type) === 'variable') {
          // TODO:多字段，常量
          params.push(record[field]);
        }
      });
      var mappingResult = attribute.mapping ? attribute.mapping(params) : [];

      if (attribute.name === 'color' && !isColor(mappingResult[0])) {
        return [minimumColor];
      }

      return mappingResult; // return attribute.mapping ? attribute.mapping(params) : [];
    }
  }, {
    key: "applyMapLayerAttributeMapping",
    value: function applyMapLayerAttributeMapping(attribute, record) {
      var _attribute$scale3;

      if (!attribute.scale) {
        return [];
      }

      var scalers = (attribute === null || attribute === void 0 ? void 0 : (_attribute$scale3 = attribute.scale) === null || _attribute$scale3 === void 0 ? void 0 : _attribute$scale3.scalers) || [];
      var params = [];
      scalers.forEach(function (_ref5) {
        var _attribute$scale4;

        var field = _ref5.field;

        if (record.hasOwnProperty(field) || ((_attribute$scale4 = attribute.scale) === null || _attribute$scale4 === void 0 ? void 0 : _attribute$scale4.type) === 'variable') {
          params.push(record[field]);
        }
      });
      var mappingResult = attribute.mapping ? attribute.mapping(params) : [];
      return mappingResult;
    }
  }, {
    key: "getArrowPoints",
    value: function getArrowPoints(p1, p2) {
      var dir = [p2[0] - p1[0], p2[1] - p1[1]];
      var normalizeDir = normalize(dir);
      var arrowPoint = [p1[0] + normalizeDir[0] * 0.0001, p1[1] + normalizeDir[1] * 0.0001];
      return arrowPoint;
    }
  }]);

  return DataMappingPlugin;
}(), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "mapService", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "fontService", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class2)) || _class);
export { DataMappingPlugin as default };